import {combineReducers} from 'redux'
import dataPlantilla from './dataReducer'
import Productos from './productosReducer'

const Reducers = combineReducers({
    dataPlantilla,
    Productos
})

export default Reducers 